import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { ListItem, ListItemAvatar, Avatar, ListItemText, Typography } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/InfoTwoTone';
import PersonIcon from '@material-ui/icons/Person';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { DateTime } from 'luxon';
import BoardPostReactions from './BoardPostReactions';
import Gallery from './Gallery';
import BoardPostAttachments from './BoardPostAttachments';
import { generateColor } from '../../../utils/avatarColorGenerator';

const BoardPost = ({ post, mainPost, onReact, onUndoReact, submitting, signedIn, closed }) => {
  let createdBy = post.createdBy || { firstName: 'Anonimowy', lastName: 'Użytkownik' };
  if (createdBy.isDeleted) {
    createdBy = { firstName: 'Usunięty', lastName: 'Użytkownik', IsDeleted: true }
  }
  return (
    <ListItem alignItems="flex-start" divider style={{ backgroundColor: post.deleted ? 'rgba(0, 0, 0, 0.05)' : post.pendingApproval ? '#fff8e1' : null }}>
      <ListItemAvatar>
        <Avatar alt={`${createdBy.firstName} ${createdBy.lastName}`} 
        style={{ backgroundColor: post.createdBy && !post.createdBy.isDeleted  ? generateColor(createdBy.firstName, createdBy.lastName) : null}}>
          {post.createdBy
          ? (post.createdBy.isDeleted ? <PersonOutlineIcon />: `${createdBy.firstName[0]}${createdBy.lastName[0]}`) 
          : <PersonIcon />}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={`${createdBy.firstName} ${createdBy.lastName}`}
        secondaryTypographyProps={{ component: 'div' }}
        secondary={
          <React.Fragment>
            {!mainPost ? <Typography variant="caption" color="textSecondary" gutterBottom>{DateTime.fromISO(post.createdAt).toFormat('dd.MM.yyyy HH:mm')}</Typography> : null}
            <div style={{ overflowWrap: 'break-word' }}>{post.content}</div>
            {post.images && post.images.length ? <Gallery photos={post.images} /> : null}
            {post.files && post.files.length ? <BoardPostAttachments files={post.files} /> : null}
            {post.censored &&
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <InfoIcon fontSize="small" color="disabled" /><Typography variant="caption" color="textSecondary" style={{ marginLeft: 4 }}>Ten wpis został automatycznie ocenzurowany</Typography>
              </div>}
            {post.deleted &&
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <InfoIcon fontSize="small" color="error" /><Typography variant="caption" color="error" style={{ marginLeft: 4 }}>Ten wpis został usunięty</Typography>
              </div>}
            {post.pendingApproval &&
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <InfoIcon fontSize="small" /><Typography variant="caption" color="textSecondary" style={{ marginLeft: 4 }}>Ten wpis oczekuje na akceptację</Typography>
              </div>}
            {!post.pendingApproval && !post.deleted ?
              <div style={{ marginTop: 16 }}>
                <BoardPostReactions id={post.id} reactions={post.reactions} onReact={onReact} onUndoReact={onUndoReact} submitting={submitting} signedIn={signedIn} disabled={closed} />
              </div> : null}
          </React.Fragment>
        }
      />
    </ListItem>
  );
};

BoardPost.propTypes = {
  t: PropTypes.func.isRequired,
  post: PropTypes.object.isRequired,
  mainPost: PropTypes.bool,
  onReact: PropTypes.func.isRequired,
  onUndoReact: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  signedIn: PropTypes.bool,
  closed: PropTypes.bool,
  authenticationRequired: PropTypes.bool,
};

export default translate()(BoardPost);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/board/BoardPost.js